import { useClientConfig } from "@/context/clientConfig";
import { getImgixImageURL } from "@/utils/image/getImgixImageURL";

export function useImgixImageURL(src?: string, params = "") {
  const { imgix: imgixConfig } = useClientConfig();

  return getImgixImageURL(src, imgixConfig, params);
}
